import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=fe1ba960&"
import script from "./ProjectInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe1ba960')) {
      api.createRecord('fe1ba960', component.options)
    } else {
      api.reload('fe1ba960', component.options)
    }
    module.hot.accept("./ProjectInformation.vue?vue&type=template&id=fe1ba960&", function () {
      api.rerender('fe1ba960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/information/ProjectInformation.vue"
export default component.exports